
<template lang="pug">
.cnmn-file-drop(@click="click")
  cnmn-file-input.cnmn-file-drop__input(
    ref="input"
    v-bind="$attrs"
    v-on="$listeners"
  )
  div 工事中
</template>

<script>
import CnmnFileInput from './cnmn-file-input'

export default {
  components: {CnmnFileInput},

  methods: {
    click() {
      this.$refs.input.click()
    },
  },
}
</script>

<style lang="sass">
.cnmn-file-drop
  background-color: yellow

.cnmn-file-drop__input
  display: none
</style>
